import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
export default function Strike(props) {
  return /*#__PURE__*/React.createElement("span", _extends({}, props.dataAttributes, {
    style: {
      textDecoration: 'line-through'
    }
  }), props.children);
}